// import moment from 'moment-timezone';
import store from '../../store';

import arrayUtil from '../../utils/arrayUtil';

const LOGIN_URL = '/authenticate';

// const ROLES_AVAILABLE = process.env.VUE_APP_ROLES_USER.split(',');

export default (creds, redirect) =>
  new Promise((resolve, reject) => {
    creds
      .post(LOGIN_URL)
      .then((data) => {
        store.dispatch('auth/login', data);
        const hasValidRole = arrayUtil.intersect(
          Object.keys(store.state.setting.authorization.startPage),
          data.user.data.roles
        );
        console.log(store.state.setting.authorization.startPage);
        if (hasValidRole.length) {
          if (redirect)
            window.router.push({
              path: redirect,
            });
          else
            window.router.push({
              name: store.state.setting.authorization.startPage[hasValidRole[0]],
            });
          resolve(data);
        } else {
          reject(data);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
